<template>
  <div class="select-course">
    <div
      v-if="isBuyClass"
      class="my-course"
      :class="tag === '' ? 'select': ''"
      @click="chooseMyCourse">
      我的课程
    </div>
    <div
      :style="{top: (!isBuyClass ? '35px' : '')}"
      class="course-center"
      :class="tag === 'experience' ? 'select-course-center': ''"
      @click="chooseCourseCenter">
      选课中心
    </div>
    <div class="left">
      <h1 class="title">学科</h1>
      <div class="courses">
        <div
          class="course"
          :class="{'active': currentCourse.courseName === course.courseName}"
          v-for="(course, index) in courses"
          :key="index"
          @click="selectCourse(course)">
            <span>{{course.courseName}}</span>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="title">
        <span class="vertical-line"></span>
        <span>课程</span>
        <el-input
          class="search-input"
          v-model="courseName"
          placeholder="搜索课程">
          <el-button
            class="btn btn-primary"
            @change="onSearchCourseName"
            @click="onSearchCourseName"
            slot="append"
            icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="content">
        <div class="subjects" v-show="searchBookList.length">
          <div class="books"
            v-for="(book, index) in searchBookList"
            :key="index">
            <div
              class="book"
              :class="{'active': currentBook.id === book.id}"
              @dblclick="start"
              @click="selectBook(book)">
              <div class="icon-wrapper">
                <div v-show="currentBookInfo.id === book.id" class="progress-wrapper">
                  <el-progress
                    color="#5256e6"
                    type="circle"
                    :percentage="currentBookInfo.progress"></el-progress>
                </div>
                <img class="icon" :src="book.cover" />
              </div>
              <div class="book-info">
                <div class="book-name">{{book.name}}</div>
                <div class="book-type">{{book.subjectName}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!searchBookList.length">
          <div class="subjects"
            v-for="(subject, index) in currentCourse.subject"
            :key="index">
            <div class="books"
              v-for="(book, index) in subject.bookList"
              :key="index">
              <div
                class="book"
                :class="{'active': currentBook.id === book.id}"
                @dblclick="start"
                @click="selectBook(book, subject)">
                <div class="icon-wrapper">
                  <div v-show="currentBookInfo.id === book.id" class="progress-wrapper">
                    <el-progress
                      color="#5256e6"
                      type="circle"
                      :percentage="currentBookInfo.progress"></el-progress>
                  </div>
                  <img class="icon" :src="book.cover" />
                </div>
                <div class="book-info">
                  <div class="book-name">{{book.name}}</div>
                  <div class="book-type">{{subject.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="title">
        <span class="vertical-line"></span>
        <span>课程介绍</span>
      </div>
      <div class="content">
        <el-carousel v-if="carouselList.length" @change="onCarouselChange" :autoplay="isAutoplay">
          <el-carousel-item
            v-for="(item, index) in carouselList"
            :key="index"
          >
            <img class="cover" :src="item.image" v-if="item.image" />
            <video
              class="cover"
              controls
              ref="video"
              :disablePictureInPicture="true"
              controlslist="nodownload "
              oncontextmenu="return false"
              @play="isAutoplay = false"
              @pause="isAutoplay = true"
              @ended="isAutoplay = true"
              v-else
              :src="item.url">
            </video>
          </el-carousel-item>
        </el-carousel>
        <div class="default-cover-wrapper" v-else>
          <img class="cover" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/848c96e6476028220d076ea99e1661a1.png" alt="">
          <div class="course-name-wrapper">
            <div class="course-name">{{currentBook.name}}</div>
            <div class="subject-name">{{currentSubjectName}}</div>
          </div>
        </div>
        <div class="name">{{currentBook.name}}</div>
        <div class="describe">{{currentBookInfo.introduction}}</div>
        <div class="total">
          <div class="item">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/eb9381d7cd280fa0d6f1991966ca60d1.png" alt="">
            <div class="number">
              <div>报名人数</div>
              <div>
                <span class="item-total">{{currentBookInfo.order}}</span>
                &nbsp;人
              </div>
            </div>
          </div>
          <div class="item">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/1c630d94ff60a59762080004d6ceb28a.png" alt="">
            <div class="number">
              <div>练习内容</div>
              <div>
                <span class="item-total">{{currentBookInfo.unit}}</span>
                &nbsp;单元
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="start btn btn-orange-square"
        :class="{'disable': currentBook.isExpire}"
        @click="start">
        <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/060d9178fa0157db28b0324d8c90f1b2.png" alt="">
        开始学习
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/graphql/learning';
import courseApi from '@/api/graphql/course';
import utils from '@/services/utils';
import {
  Input,
  Button,
  Progress,
  Carousel,
  CarouselItem,
} from 'element-ui';

export default {
  components: {
    ElInput: Input,
    ElButton: Button,
    ElProgress: Progress,
    ElCarousel: Carousel,
    ElCarouselItem: CarouselItem,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tag: '',
      isBuyClass: true,
      courses: [],
      currentCourse: {},
      currentBook: {},
      currentBookInfo: {},
      courseName: '',
      carouselList: [],
      searchBookList: [],
      isAutoplay: true,
    };
  },
  watch: {
    courseName() {
      this.onSearchCourseName();
    },
    currentBook() {
      const { id } = this.currentBook;
      this.getCourseInfo(id);
    },
    isShow() {
      if (this.isShow) {
        this.fetchCourseList();
      } else {
        this.tag = '';
        this.onCarouselChange();
      }
    },
  },
  computed: {
    currentSubjectName() {
      const { subjectName = '' } = this.currentBook;
      const subject = subjectName.split('-');
      return subject.length >= 2 ? subject[1] : '';
    },
  },
  methods: {
    fetchCourseList() {
      api
        .getCourseList({
          type: this.tag,
        })
        .then(({ courses }) => {
          this.searchBookList = [];
          let defaultCourse;
          this.courses = courses;

          if (!this.courses.length && this.tag === '') {
            this.isBuyClass = false;
            this.tag = 'experience';
            this.fetchCourseList();
          }

          if (this.courses.length) {
            if (this.currentCourse.courseName) {
              const course = utils.Array.find(this.courses, this.currentCourse, 'courseName');
              if (course) {
                defaultCourse = course;
              } else {
                const [firstCourse] = this.courses;
                defaultCourse = firstCourse;
              }
            } else {
              const [firstCourse] = this.courses;
              defaultCourse = firstCourse;
            }

            if (defaultCourse) {
              const { subject: [firstBookList] } = defaultCourse;
              const { bookList } = firstBookList;
              const [firstBook] = bookList;

              this.currentCourse = defaultCourse;
              this.currentBook = {
                ...firstBook,
                subjectName: firstBookList.name,
              };
            }
          }
        });
    },
    chooseMyCourse() {
      this.tag = '';
      this.courseName = '';
      this.searchBookList = [];
      this.fetchCourseList();
    },
    chooseCourseCenter() {
      this.tag = 'experience';
      this.courseName = '';
      this.searchBookList = [];
      this.fetchCourseList();
    },
    onSearchCourseName() {
      const { subject = [] } = this.currentCourse;
      this.searchBookList = [];
      subject.forEach((item) => {
        item.bookList.forEach((book) => {
          const reg = new RegExp(this.courseName);
          if (reg.test(book.name)) {
            this.searchBookList.push({
              ...book,
              subjectName: item.name,
            });
          }
        });
      });

      if (!this.searchBookList.length) {
        utils.debounce(() => {
          utils.error('暂无相关课程，请检查关键字');
        }, 1000)();
      }
    },
    selectCourse(course) {
      this.courseName = '';
      this.searchBookList = [];
      this.currentCourse = course;
    },
    selectBook(book, subject) {
      this.currentBook = book;
      if (subject) {
        this.currentBook.subjectName = subject.name;
      }
    },
    start() {
      let scene;
      let type;

      if (this.currentBook.isExpire) return;
      if (this.currentBook.type === 'BDC') {
        scene = 'wordUnit';
        type = 'bdc_learn';
      } else if (this.currentBook.type === 'DS') {
        scene = 'dsUnit';
        // type = 'bdc_learn';
      } else {
        scene = 'unitModule';
      }
      this.$emit('change', {
        scene,
        params: {
          course: this.currentBook,
          type,
        },
      });
    },
    getCourseInfo(id) {
      courseApi.getCourseInfo({
        id,
      }).then(({ courseInfo }) => {
        const { videos, banners } = courseInfo;
        this.currentBookInfo = {
          ...courseInfo,
          id,
        };
        this.carouselList = [...videos, ...banners];
      });
    },
    onCarouselChange() {
      const videos = this.$refs.video;
      if (videos) {
        videos.forEach((video) => {
          video.pause();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .select-course {
    display: flex;
    position: absolute;
    left: calc(50% - 70vh);
    top: calc(50% - 40vh);
    height: 80vh;
    background: $primary;
    border-radius: 24px;
    .my-course {
      position: absolute;
      left: -36px;
      top: 35px;
      width: 20px;
      padding: 13px 8px;
      color: #fff;
      text-align: center;
      background-color: #0BC679;
      font-size: 14px;
      font-weight: bold;
      border-top-left-radius: 22px;
      border-bottom-left-radius: 22px;
      cursor: pointer;
    }
    .course-center {
      position: absolute;
      left: -36px;
      top: 153px;
      width: 20px;
      padding: 13px 8px;
      color: #fff;
      text-align: center;
      background-color: #45a0eb;
      font-size: 14px;
      font-weight: bold;
      border-top-left-radius: 22px;
      border-bottom-left-radius: 22px;
      cursor: pointer;
    }
    .select {
      font-size: 18px;
      padding: 18px 13px;
      left: -46px;
    }
    .select-course-center {
      font-size: 18px;
      padding: 18px 13px;
      left: -46px;
      top: 125px;
    }
    .left {
      width: 15vh;
      height: 100%;
      color: #fff;
      .title {
        margin: 4vh 0;
        font-size: 2.3vh;
        text-align: center;
      }
      .courses {
        .course {
          height: 4.63vh;
          margin: 1.4vh 0;
          padding: .5vh 0;
          font-size: 2vh;
          line-height: 4.63vh;
          font-weight: 700;
          text-align: center;
          cursor: pointer;
          span {
            display: inline-block;
            transition: transform .15s;
            &:hover {
              transform: scale(1.05);
            }
          }
          &.active {
            color: $primary;
            background: #fff;
          }
        }
      }
    }
    .center {
      display: flex;
      flex-direction: column;
      width: 60vh;
      margin: 10px 0;
      height: calc(100% - 20px);
      background: #fff;
      border-radius: 18px;
      .title {
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin: 2.31vh 0 0.9vh;
        padding-left: 2.6vh;
        font-size: 2.5vh;
        font-weight: 700;
        .vertical-line {
          display: inline-block;
          width: 3px;
          height: 15px;
          margin-right: 1vh;
          background: $primary;
          border-radius: 18px;
        }
        /deep/ .search-input {
          position: absolute;
          right: 20px;
          width: 200px;
          text-align: center;
          .el-input-group__append {
            background: $primary;
            border-width: 1px 0;
            border-color: $primary;
            cursor: pointer;
            &:hover {
              filter: brightness(108%);
            }
            .el-button {
              padding: 1vh;
              .el-icon-search {
                color: #fff;
              }
            }
          }
          .is-active, .el-input__inner:focus {
            border-color: $primary;
          }
        }
      }
      .content {
        box-sizing: border-box;
        padding-left: 2.6vh;
        padding-right: 1vh;
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        border-radius: 18px;
        .subjects {
          box-sizing: border-box;
          padding-bottom: 1.39vh;
          .books {
            .book {
              box-sizing: border-box;
              display: flex;
              align-items: center;
              margin-top: 1.48vh;
              padding: 1vh;
              width: 100%;
              border-radius: 18px;
              cursor: pointer;
              &.active {
                background: #e8e9fc;
                .book-info {
                  .book-name {
                    color: $primary;
                    font-weight: 700;
                  }
                  .book-type {
                    width: 100%;
                    color: $primary;
                    font-weight: 700;
                  }
                }
              }
              &:hover {
                transform: scale(1.02);
              }
              .icon-wrapper {
                position: relative;
                width: 13vh;
                height: 17vh;
                border-radius: 10px;
                overflow: hidden;
                .icon {
                  width: 100%;
                  height: 100%;
                }
                .progress-wrapper {
                  position: absolute;
                  left: 0;
                  top: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 100%;
                  background: rgba($color: #000000, $alpha: .5);
                  /deep/ .el-progress {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 8vh;
                    height: 8vh;
                    .el-progress-circle {
                      width: 100%!important;
                      height: 100%!important;
                    }
                    .el-progress__text {
                      color: #fff;
                    }
                  }
                }
              }
              .book-info {
                margin-left: 1.85vh;
                width: 60%;
                color: #333;
                .book-name {
                  margin-bottom: 1.39vh;
                  width: 100%;
                  font-size: 2.85vh;
                  font-weight: 700;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
                .book-type {
                  width: 100%;
                  font-size: 2vh;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
            }
          }
        }
      }
    }
    .right {
      position: relative;
      box-sizing: border-box;
      margin: 10px 10px 10px 2vh;
      padding: 0 2.67vh;
      width: 65vh;
      height: calc(100% - 20px);
      background: #fff;
      border-radius: 18px;
      .title {
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin: 2.31vh 0 2vh;
        font-size: 2.5vh;
        font-weight: 700;
        .vertical-line {
          display: inline-block;
          width: 3px;
          height: 15px;
          margin-right: 1vh;
          background: $primary;
          border-radius: 18px;
        }
      }
      .content {
        /deep/ .el-carousel {
          .el-carousel__container {
            width: 100%;
            height: 30vh;
          }
        }
        .cover {
          width: 100%;
          height: 30vh;
          background: rgba($color: #333, $alpha: .1);
          border-radius: 20px;
        }
        .default-cover-wrapper {
          position: relative;
          .course-name-wrapper {
            position: absolute;
            top: 50%;
            width: 100%;
            text-align: center;
            transform: translateY(-50%);
            color: #fff;
            .course-name {
              font-size: 3.5vh;
              font-weight: 700;
              text-shadow: $primary -2px 2px 2px;
            }
            .subject-name {
              margin-top: 1.5vh;
              font-size: 2.5vh;
              font-weight: 700;
              text-shadow: red 0px 0px 2px;
            }
          }
        }
        .name {
          margin: 2.59vh 0 1.8vh 1vh;
          font-size: 2.59vh;
          font-weight: 700;
        }
        .describe {
          box-sizing: border-box;
          padding-right: 1.67vh;
          max-height: 12vh;
          font-size: 1.9vh;
          line-height: 1.5;
          text-indent: 12px;
          overflow-y: auto;
        }
        .total {
          display: flex;
          justify-content: space-around;
          margin-top: 3vh;
          .item {
            margin-right: 2vh;
            display: flex;
            align-items: center;
            img {
              width: 6vh;
            }
            .number {
              margin-left: 0.5vh;
              div {
                margin: 0.25vh 0;
              }
              .item-total {
                font-weight: 700;
              }
            }
          }
        }
      }
      .start {
        position: absolute;
        left: 50%;
        bottom: 5vh;
        font-size: 2vh;
        transform: translateX(-50%);
        cursor: pointer;
        &.disable {
          filter: grayscale(100%);
        }
        &:hover {
          opacity: .8;
        }
        img {
          margin-left: -2vh;
          width: 4vh;
        }
      }
    }
  }
</style>
